import { makeRequestAuth, uploadRequest } from "../utils/globals";

class BulkProcessService {
  /*
   * @param
   * @returns {promise}
   * ulpoads file for bulk processing
   */
  uploadFile(uploadData) {
    const formData = new FormData();
    formData.append("mail_details", JSON.stringify(uploadData.mail_details));
    formData.append("campaign_id", uploadData.campaign_id);
    formData.append("attachments", uploadData.attachments);
    formData.append("sms_details", JSON.stringify(uploadData.sms_details));
    formData.append("skip_filename_check", uploadData.skip_filename_check);
    formData.append("reward_type", uploadData.reward_type);
    formData.append("expiry_month", uploadData.expiry_month);
    formData.append("delivery_method", uploadData.delivery_method);
    if (uploadData.authentication_type) {
      formData.append("authentication_type", uploadData.authentication_type);
    }
    // formData.append("isCxml", uploadData.isCxml);
    return new Promise((resolve, reject) => {
      uploadRequest(
        formData,
        function (response) {
          if (response) {
            resolve(response);
          } else {
            resolve({});
          }
        }.bind(this),
        "/api/graph/v1_bulk_upload"
      );
    });
  }

  bulkProcess(params) {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.mutation.bulkProcess",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  getBatchStatus = (params) => {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.query.bulkProcessGetBatchStatus",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  cancelBatch = (params) => {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.mutation.bulkCancelBatch",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  fetchSchedulerReport = (params, signal = false) => {
    return new Promise((resolve, reject) => {
      const fetchSchedule = {
        query: "storesAdmin.query.fetchScheduleReport",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(
        fetchSchedule,
        (response) => {
          if (response && response.data && response.data.fetchScheduleReport) {
            resolve(response.data);
          } else {
            resolve({});
          }
        },
        "",
        "",
        signal
      );
    });
  };

  cancelScheduledData = (params) => {
    return new Promise((resolve, reject) => {
      const cancelSchedule = {
        query: "storesAdmin.mutation.bulkCancelScheduleData",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(cancelSchedule, (response) => {
        if (response && response.data && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };
}

export default Object.freeze(new BulkProcessService());
